<template type="x/template">
  <transition name="modal" id="stock-transaction-dialog">
    <DxPopup
      id="dx-dialog"
      width="100vw"
      height="100vh"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      :resize-enabled="false"
      :drag-enabled="false"
      @hidden="$emit('hidden')"
      :wrapper-attr="popupAttributes"
    >
      <template #title>
        <div class="transactions_header">
          <div class="left_side">
            <div @click="backButtonEvent" class="back_button" v-show="currentStep > 0">
              <img src="@/assets/images/icons/arrow-back.svg" />
              <div class="back_button_text">{{ $t("common.back") }}</div>
            </div>
          </div>
          <div class="right_side">
            <img class="close_button" src="@/assets/images/icons/dialog-close.svg" @click="buttonCloseEvent" />
          </div>
        </div>
      </template>

      <template #content>
        <div class="transactions_content">
          <DxTabPanel
            ref="selectorTabPanel"
            :element-attr="tabPanelAttributes"
            :data-source="transactionSteps"
            :loop="false"
            :selected-item="currentItem"
            :selected-index="currentStep"
            :animation-enabled="true"
            :swipe-enabled="false"
            :show-nav-buttons="false"
            @selection-changed="tabSelectionChanged($event)"
          >
            <template #item="{ data: step }">
              <div class="transaction_tab_panels_container">
                <div class="dialog_title_container" v-if="true">
                  <div v-if="step == 1" class="title_text">{{ $t("stock_mobile.transactions.title") }}</div>
                  <div
                    v-if="step > 1 && !!currentTransactionTitleText"
                    class="title_text"
                    :class="alignTitleLeft ? 'title_text_left' : 'title_text'"
                  >
                    {{ currentTransactionTitleText }}
                  </div>
                  <div class="transaction_sub_title_text" v-if="step > 1 && !!subtitleText1 && !!subtitleText2">
                    {{ subtitleText1 }}<span style="color: #096c27">{{ subtitleText2 }}</span>
                  </div>
                  <div class="title_right_icon" v-if="showBarcodeIcon()" @click="barcodeClick">
                    <img src="@/assets/images/icons/barcode_icon.svg" />
                  </div>
                  <div v-if="addButtonVisibility">
                    <b-button
                      v-if="addButtonVisibility"
                      class="selector_add_icon"
                      variant="outline-secondary"
                      size="sm"
                      pill
                      @click="detailSelectorAdd"
                      ><img src="@/assets/images/icons/plus.svg"
                    /></b-button>
                  </div>
                </div>
                <div v-if="step == 1" class="transaction_step option_selector_container">
                  <div
                    v-for="option in transactionOptions"
                    :key="option.code"
                    class="transaction_selector_option"
                    @click="transactionOptionClick(option)"
                  >
                    {{ option.title }}
                  </div>
                </div>
                <div v-if="step == 2">
                  <reception
                    v-if="currentTransaction.code == transactionActions.Receptie"
                    ref="reception"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @changeAddButtonVisibility="changeAddButtonVisibility"
                    @closeTransactions="buttonCloseEvent"
                    @startConsumFromRecpetion="startConsumFromRecpetion"
                  ></reception>
                  <Production
                    v-if="currentTransaction.code == transactionActions.Production"
                    ref="production"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @changeAddButtonVisibility="changeAddButtonVisibility"
                    @closeTransactions="buttonCloseEvent"
                  ></Production>
                  <transfer
                    v-if="currentTransaction.code == transactionActions.Transfer"
                    ref="transfer"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @changeAddButtonVisibility="changeAddButtonVisibility"
                    @closeTransactions="buttonCloseEvent"
                  ></transfer>
                  <consum
                    v-if="currentTransaction.code == transactionActions.Consum"
                    ref="consum"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @closeTransactions="buttonCloseEvent"
                    :preselectProducts="preselectProducts"
                    :preselectedWorksData="preselectedWorksData"
                    :preselectedMachineForConsum="preselectedMachineForConsum"
                    :enableParcelMapListToggle="true"
                    parcelInitialView="map"
                  ></consum>
                  <sales
                    v-if="currentTransaction.code == transactionActions.Vanzare"
                    ref="sales"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @closeTransactions="buttonCloseEvent"
                  ></sales>
                  <recalificare
                    v-if="currentTransaction.code == transactionActions.Recalificare"
                    ref="recalificare"
                    @goBackParent="goBackParent"
                    @setTitle="setTitle"
                    @closeTransactions="buttonCloseEvent"
                  ></recalificare>
                </div>
              </div>
            </template>
          </DxTabPanel>
          <toast-message ref="toastMessage"></toast-message>
        </div>
      </template>
    </DxPopup>
  </transition>
</template>

<script>
import { DxPopup, DxPosition } from "devextreme-vue/popup";
import DxTabPanel from "devextreme-vue/tab-panel";
import Reception from "./partials/reception.vue";
import Production from "./partials/production.vue";
import Transfer from "./partials/transfer.vue";
import Consum from "./partials/consum.vue";
import Sales from "./partials/sales.vue";
import Recalificare from "./partials/recalificare.vue";
import { TransactionActions, TransactionOptions } from "./transactions";
import ToastMessage from "../../../components/Mobile/toastMessage.vue";

export default {
  name: "Transactions",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    autoOpenConsum: {
      type: Boolean,
      default: false,
    },
    autoConsumOption: {
      type: String,
      default: "",
    },
    forceOpenConsum: {
      type: Boolean,
      default: false,
    },
    forceConsumOption: {
      type: String,
      default: "",
    },
    preselectedWorksData: {
      type: Object,
      default: null,
    },
    preselectedProductsForConsum: {
      type: Object,
      default: null,
    },
    preselectedMachineForConsum: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      popupAttributes: {
        class: "transaction_dialog_wrapper",
      },
      tabPanelAttributes: {
        class: "transaction_tabs",
      },
      transactionSteps: [1, 2],
      currentStep: 0,
      currentItem: 1,
      currentTransaction: {},
      currentTransactionTitleText: "",
      addButtonVisibility: false,
      alignTitleLeft: false,
      subtitleText1: "",
      subtitleText2: "",
      preselectProducts: null,
      titleVisibility: true,
      autoOpenApplied: false,
    };
  },
  components: {
    DxPopup,
    DxPosition,
    DxTabPanel,
    Reception,
    Production,
    ToastMessage,
    Transfer,
    Consum,
    Sales,
    Recalificare,
  },
  watch: {
    showPopup(newVal) {
      if (!newVal) {
        this.resetForm();
      } else {
        this.preselectProducts = this.clonePreselectedProducts(this.preselectedProductsForConsum);
        if (this.forceOpenConsum) {
          this.autoOpenApplied = true;
          this.openConsumFlow(this.forceConsumOption);
        } else if (this.autoOpenConsum && !this.autoOpenApplied) {
          this.autoOpenApplied = true;
          this.openConsumFlow(this.autoConsumOption);
        }
      }
    },
    preselectedProductsForConsum: {
      handler(newVal) {
        this.preselectProducts = this.clonePreselectedProducts(newVal);
      },
      deep: true,
    },
    currentTransaction(newVal) {},
  },
  computed: {
    transactionActions() {
      return TransactionActions;
    },
    transactionOptions() {
      return TransactionOptions.map((option) => ({
        ...option,
        title: this.getTransactionTitle(option.code),
      }));
    },
  },
  methods: {
    getTransactionTitle(code) {
      const keyMap = {
        [this.transactionActions.Receptie]: "stock_mobile.transactions.reception",
        [this.transactionActions.Production]: "stock_mobile.transactions.production",
        [this.transactionActions.Transfer]: "stock_mobile.transactions.transfer",
        [this.transactionActions.Consum]: "stock_mobile.transactions.consum",
        [this.transactionActions.Vanzare]: "stock_mobile.transactions.sales",
        [this.transactionActions.Recalificare]: "stock_mobile.transactions.reclassification",
        [this.transactionActions.Casare]: "stock_mobile.transactions.scrap",
      };

      const key = keyMap[code];
      return key ? this.$t(key) : code;
    },
   clonePreselectedProducts(value) {
      if (!value) {
        return null;
      }

      return JSON.parse(JSON.stringify(value));
    },
    openConsumFlow(optionCode = "") {
      const consumOption = this.transactionOptions.find((opt) => opt.code === this.transactionActions.Consum);
      this.currentTransaction = consumOption || {
        code: this.transactionActions.Consum,
        title: this.getTransactionTitle(this.transactionActions.Consum),
      };
      this.currentStep = 1;
      this.currentItem = this.transactionSteps[1];
      this.$nextTick(() => {
        if (this.$refs.consum && optionCode) {
          this.$refs.consum.startFromOption(optionCode);
        }
      });
    },
    showBarcodeIcon() {
      return (
        (this.currentTransaction.code == this.transactionActions.Receptie && this.$refs.reception?.getCurrentStep() == 0) ||
        (this.currentTransaction.code == this.transactionActions.Transfer && this.$refs.transfer?.getCurrentStep() == 0)
      );
    },
    startConsumFromRecpetion(receptionData) {
      this.preselectProducts = receptionData;
      this.backButtonEvent();
      this.currentStep = 1;
      this.currentTransaction = {
        code: this.transactionActions.Consum,
        title: this.getTransactionTitle(this.transactionActions.Consum),
      };
    },
    backButtonEvent() {
      if (this.currentItem == 1) {
        this.$emit("hidden");
      } else {
        if (this.currentTransaction.code == this.transactionActions.Receptie) {
          this.$refs.reception.goBack();
        }
        if (this.currentTransaction.code == this.transactionActions.Production) {
          this.$refs.production.goBack();
        }
        if (this.currentTransaction.code == this.transactionActions.Transfer) {
          this.$refs.transfer.goBack();
        }
        if (this.currentTransaction.code == this.transactionActions.Consum) {
          this.titleVisibility = true;
          this.$refs.consum.goBack();
        }
        if (this.currentTransaction.code == this.transactionActions.Vanzare) {
          this.$refs.sales.goBack();
        }
        if (this.currentTransaction.code == this.transactionActions.Recalificare) {
          this.$refs.recalificare.goBack();
        }
        //this.currentStep = this.currentStep - 1;
      }
    },
    buttonCloseEvent(message) {
      this.$emit("hidden");
      if (message && message.length > 0) {
        this.$emit("showTransactionMessage", message);
      }
    },
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.transactionSteps.indexOf(this.currentItem);
    },
    transactionOptionClick(trans) {
      if (
        trans.code == this.transactionActions.Receptie ||
        trans.code == this.transactionActions.Production ||
        trans.code == this.transactionActions.Transfer ||
        trans.code == this.transactionActions.Consum ||
        trans.code == this.transactionActions.Vanzare ||
        trans.code == this.transactionActions.Recalificare
      ) {
        this.currentTransaction = trans;
        this.currentStep = this.currentStep + 1;
      } else {
        this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
      }
    },
    barcodeClick() {
      this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
      // console.log(this.currentTransaction.code);
      // console.log(this.transactionActions.Receptie);
      // if(this.currentTransaction.code == this.transactionActions.Receptie){
      //   this.$refs.reception.goForward();
      // }
    },
    goBackParent() {
      if (this.currentStep == 1) {
        this.currentTransaction = {};
      }
      this.currentStep = this.currentStep - 1;
    },
    setTitle(titleText, alignLeft, subt1 = "", subt2 = "", titleVisibility = true) {
      this.currentTransactionTitleText = titleText;
      this.alignTitleLeft = alignLeft;
      this.subtitleText1 = subt1;
      this.subtitleText2 = subt2;
      this.titleVisibility = titleVisibility;
    },
    detailSelectorAdd() {
      if (this.currentTransaction.code == this.transactionActions.Receptie) {
        this.$refs.reception.goForward();
      }
      if (this.currentTransaction.code == this.transactionActions.Transfer) {
        this.$refs.transfer.goForward();
      }
    },
    changeAddButtonVisibility(visibility) {
      this.addButtonVisibility = visibility;
    },
    resetForm() {
      this.currentStep = 0;
      this.currentTransaction = {};
      this.subtitleText1 = "";
      this.subtitleText2 = "";
      this.autoOpenApplied = false;
      this.preselectProducts = null;
    },
    showMessage(message) {
      this.$emit("showTransactionMessage", message);
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/transactions.scss";
</style>
